import axios from 'axios';

const state = {
  roadtrips: {
    roadtrips: {
      trips: null,
    },
  },
  fullCount: 0,
  page: {
    pageSize: 27,
    page: 1,
  },
};

const getters = {};

const actions = {
  async getRoadtrips({ commit, state: st }, selected) {
    let url = `${process.env.VUE_APP_ROADTRIPS}`;
    url += `?paging=true&page=${st.page.page}&pageSize=${st.page.pageSize}`;

    if (selected && selected.experienceTypes.length > 0) {
      url += `&expTypefiltering=true&expTypefilter=${JSON.stringify(selected.experienceTypes)}`;
    }

    if (selected && selected.regions.length > 0) {
      url += `&regionfiltering=true&regionfilter=${JSON.stringify(selected.regions)}`;
    }

    await axios.get(url, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        Accept: 'application/json',
      },
    }).then((response) => {
      commit('SET_ROADTRIPS', response.data);
      commit('SET_COUNT', response.data.count);
    });
  },
  async setPage({ commit, dispatch }, payload) {
    commit('SET_PAGE', payload.page);
    await dispatch('getRoadtrips', payload.selected);
  },
  async setCount({ commit }, count) {
    commit('SET_COUNT', count);
  },
};

const mutations = {
  SET_ROADTRIPS(st, roadtrips) {
    st.roadtrips = roadtrips;
  },
  SET_COUNT(st, count) {
    st.fullCount = count;
  },
  SET_PAGE(st, page) {
    st.page.page = page;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
